<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Nacht im Forst</h3>
<p class="vers">Wald und Weide liegen<br class="calibre2"/>
tief in Nacht gehüllt;<br class="calibre2"/>
Kauz und Eule fliegen,<br class="calibre2"/>
und es schläft das Wild.</p>
<p class="vers">Schwarze Tannen heben<br class="calibre2"/>
stumm sich himmelan;<br class="calibre2"/>
alles ohne Leben<br class="calibre2"/>
rings im weiten Tann.</p>
<p class="vers">Mondesampel steiget<br class="calibre2"/>
übers Wipfelmeer;<br class="calibre2"/>
doch im Glanze schweiget<br class="calibre2"/>
alles wie bisher.</p>
<p class="vers">Licht und Dunkel schlingen<br class="calibre2"/>
lautlos Hand in Hand,<br class="calibre2"/>
und du scheinst zu dringen<br class="calibre2"/>
in ein Fabelland. <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page32" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0018.vue?254ecdb6